var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExportIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.09091 1.63636C1.09091 1.33512 1.33512 1.09091 1.63636 1.09091H5.45455C5.75579 1.09091 6 0.846701 6 0.545455C6 0.244208 5.75579 0 5.45455 0H1.63636C0.732625 0 0 0.732625 0 1.63636V10.3636C0 11.2674 0.732625 12 1.63636 12H10.3636C11.2674 12 12 11.2674 12 10.3636V6.54545C12 6.24421 11.7558 6 11.4545 6C11.1533 6 10.9091 6.24421 10.9091 6.54545V10.3636C10.9091 10.6649 10.6649 10.9091 10.3636 10.9091H1.63636C1.33512 10.9091 1.09091 10.6649 1.09091 10.3636V1.63636Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.18182 0C7.88057 0 7.63636 0.244208 7.63636 0.545455C7.63636 0.846701 7.88057 1.09091 8.18182 1.09091H10.1377L3.97794 7.25067C3.76493 7.46368 3.76493 7.80905 3.97794 8.02206C4.19096 8.23507 4.53632 8.23507 4.74933 8.02206L10.9091 1.8623V3.81818C10.9091 4.11943 11.1533 4.36364 11.4545 4.36364C11.7558 4.36364 12 4.11943 12 3.81818V0.545455C12 0.244208 11.7558 0 11.4545 0H8.18182Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExportIcon);
export default __webpack_public_path__ + "static/media/export-icon.a13b209b3490611f05577ace4e97105b.svg";
export { ForwardRef as ReactComponent };